module.exports = __webpack_public_path__ + "static/media/DSCF6380_segundaaparicion.b820ab75.jpg";